<template>
  <div>
    <LeftListMember :pos="10"></LeftListMember>
    <div class="g-row2">
      <div class="m-hone1">
        <ul class="g-tablist1">
          <li class="li">
            <router-link to="/member-download-center" class="txt"
              >数据下载</router-link
            >
          </li>
          <li class="li">
            <router-link to="/member-task-center" class="txt">下载中心</router-link>
          </li>
          <li class="li on">
            <router-link to="/member-search-center" class="txt">批量检索</router-link>
          </li>
        </ul>
        <div class="contect">
          <div class="s-infobox2">
            <div class="tit_button">
              <div class="list-tit">批量检索列表</div>
              <el-button
                type="danger"
                :disabled="multipleSelection.length === 0"
                @click="batchDelete">
                批量删除
              </el-button>
            </div>
            <el-table
              ref="multipleTable"
              :data="tableData"
              tooltip-effect="dark"
              style="width: 100%"
              @selection-change="handleSelectionChange">
              <el-table-column type="selection" width="55"> </el-table-column>
              <el-table-column label="任务名称" width="210" prop="title">
                <!-- <template slot-scope="scope">{{ scope.row.date }}</template> -->
              </el-table-column>


              <el-table-column prop="schedule" label="任务进度" width="250">
                <template slot-scope="scope">
                  <span>共{{ scope.row.count }}条，已下载{{scope.row.success}}条，{{Math.round(scope.row.success*1000/scope.row.count)/10}}%</span>
                </template>
              </el-table-column>

              <el-table-column prop="download" label="结果下载" width="280">
                <template slot-scope="scope">
                  <span v-if="scope.row.status == 2">
                    <a class="download-btn" :class="{on:scope.row.status == 2}" @click="downloadSuccess(scope.row)">表单下载</a>&nbsp;&nbsp;
                    <a class="download-btn red" :class="{on:scope.row.status == 2}" @click="downloadFail(scope.row)">未命中数据</a>
                  </span>
                </template>
              </el-table-column>

              <el-table-column label="状态" width="120">
                <template slot-scope="scope">
                  <el-tag
                    :type="scope.row.statusOptionName === '已完成' ? 'over2' : 'over'"
                    disable-transitions
                    >{{ scope.row.statusOptionName }}</el-tag
                  >
                </template>
              </el-table-column>

              <el-table-column prop="typeOptionName" label="任务类型" width="100">
              </el-table-column>
              <el-table-column prop="createtime" label="创建时间" width="240">
              </el-table-column>

              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    type="danger"
                    @click="Delete(scope.$index, scope.row)"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
            <div class="fy">
              <el-pagination
                :current-page.sync="page.page"
                :page-sizes="[10, 20, 50, 100]"
                :page-size.sync="page.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="page.count">
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LeftListSupplier from "@/components/LeftListSupplier";
import dayjs from "dayjs";
import getApiData, {getApiRes} from "@/api/apiUtil";
import LeftListMember from "@/components/LeftListMember.vue";
import apiBkSearchTask from "@/api/bkSearchTask";
export default {
  components: {
    LeftListMember,
    LeftListSupplier,
  },
  data() {
    return {
      tableData: [
        // {
        //   id: 1,
        //   title: "2025新书下载数据",
        //   createtime: "2024-04-06 10:00",
        //   schedule: "共计：10000条;  下载9000条;",
        //   download: "Marc下载     表单下载       未命中数据  ",
        //   result: "已完成",
        //   leix: "下载任务",
        // },
        // {
        //   id: 2,
        //   title: "测试数据订单",
        //   createtime: "2024-04-06 10:00",
        //   schedule: "共计：4000条;  下载1000条;",
        //   download: "Marc下载     表单下载       未命中数据  ",
        //   result: "未完成",
        //   leix: "订单任务",
        // },
      ],
      page: {
        page: 1,
        pageSize: 10,
        count: 0,
      },
      multipleSelection: [],
      nextId: 4,
    };
  },
  computed: {
    dialogTitle() {
      return this.dialogType === "add" ? "新增服务器" : "修改服务器";
    },

    userInfo() {
      return this.$store.state.user.userInfo;
    },
    isVip() {
      return (
        dayjs(this.$store.state.user.userInfo.vipTime).unix() > dayjs().unix()
      );
    },
  },
  watch: {
    'page.page'(v){
      this.load(v)
    },
    'page.pageSize'(v){
      this.load(1)
    }
  },
  mounted() {
    this.load()
    // 定时刷新
    this.interval = setInterval(() => {
      this.load(this.page.page)
    }, 60000)
  },
  beforeDestroy() {
    if(this.interval) clearInterval(this.interval)
  },
  methods: {
    async load(page = 1){
      if(page == 1) this.tableData = []
      this.page.page = page
      let re = await getApiRes(apiBkSearchTask.getList(this.page.page, this.page.pageSize), 0, 1)
      if(re.data) this.tableData = re.data
      this.page.count = re.count
    },
    async downloadSuccess(task){
      if(task.count - task.fail <=0) return this.$message.error('没有成功的记录')
      window.open(`/home/bk_search_task/downloadSuccessItems?id=${task.id}`, '_blank')
    },
    async downloadFail(task){
      if(task.fail <=0) return this.$message.error('没有失败的记录')
      window.open(`/home/bk_search_task/downloadFailItems?id=${task.id}`, '_blank')
    },
    batchDelete() {
      if (this.multipleSelection.length === 0) {
        this.$message.warning("请选择要删除的任务");
        return;
      }
      this.$confirm(
        `确定要删除选中的${this.multipleSelection.length}条任务吗？`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(async () => {
          // 获取所有要删除的id
          const ids = this.multipleSelection.map((item) => item.id);
          // 调用接口删除
          let re = await getApiRes(apiBkSearchTask.listDel(ids), 0, 1)
          if(re.code !=0) return;
          // 过滤掉这些id
          this.tableData = this.tableData.filter(
            (item) => !ids.includes(item.id)
          );
          this.$message.success("删除成功");
          // 清空选中
          this.$refs.multipleTable.clearSelection();
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },
    Delete(index, row) {
      this.$confirm("此操作将永久删除该任务, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          // 调用接口删除
          let re = await getApiRes(apiBkSearchTask.listDel(row.id), 0, 1)
          if(re.code !=0) return;
          // 根据id删除
          this.tableData = this.tableData.filter((item) => item.id !== row.id);
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
  },
};
</script>

<style lang="scss" scoped>
.download-btn{
  display: inline-block;
  padding: 0.5vw 0.2vw;
  line-height: 0.5vw;
  background: lightgrey;
  color: #000;
}
.download-btn.on{
  background: #1690ff;
  color: #fff;
}
.download-btn.red{
  background-color: #fd475d;
}
.download-btn.green{
  background-color: #03bc64;
}
</style>
